// Sets the viewport size in the store (host only) for the
// app to get context of the available space
export default store => {
  store.dispatch('setHostViewport')
  // Listen to resize events
  window.addEventListener('resize', () => {
    store.dispatch('setHostViewport')
  })
}
